module.exports = __webpack_public_path__ + "assets/5860f600070b717e3f3a268622054664.svg";